import { render, staticRenderFns } from "./ValidationResult.vue?vue&type=template&id=21bdef7c&scoped=true"
import script from "./ValidationResult.ts?vue&type=script&lang=ts&external"
export * from "./ValidationResult.ts?vue&type=script&lang=ts&external"
import style0 from "./ValidationResult.vue?vue&type=style&index=0&id=21bdef7c&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21bdef7c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src120839944/src/sctd-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('21bdef7c')) {
      api.createRecord('21bdef7c', component.options)
    } else {
      api.reload('21bdef7c', component.options)
    }
    module.hot.accept("./ValidationResult.vue?vue&type=template&id=21bdef7c&scoped=true", function () {
      api.rerender('21bdef7c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/Modules/Processes/components/details/ValidationResult/ValidationResult.vue"
export default component.exports